// import Tween from 'gsap-promise';

import { bindEvents, addListener, removeListener } from '../../assets/js/helpers';

export const selector = 'overview';

export default class Overview {

	constructor(section) {
		this.el = {
			section,
			toggles: section.querySelectorAll(`.${selector}__detail-toggles button`),
			detailSections: section.querySelectorAll(`.${selector}__detail-contents section`)
		};

		this.events = bindEvents(this);
		this.addEventListeners();
	}

	updateToggles(nextToggle) {
		for (const toggle of this.el.toggles) {
			toggle.classList.remove('is-active');
			toggle.setAttribute('aria-expanded', 'false');
		}

		nextToggle.classList.add('is-active');
		nextToggle.setAttribute('aria-expanded', 'true');
	}

	updateDetailSections(sectionId) {
		const currentSection = Array.from(this.el.detailSections).filter((el) => el.classList.contains('is-active'));
		const nextSection = this.el.section.querySelector(`#${sectionId}`);
		const animateOutComplete = () => {
			currentSection[0].removeEventListener('transitionend', animateOutComplete);
			currentSection[0].classList.remove('animate-out');
			nextSection.classList.add('is-active');
			this.el.section.style.minHeight = '';
		};

		if (nextSection.classList.contains('is-active')) {
			return;
		}

		this.el.section.style.minHeight = `${this.el.section.clientHeight}px`;
		currentSection[0].addEventListener('transitionend', animateOutComplete);

		for (const section of this.el.detailSections) {
			section.classList.remove('is-active');
		}

		currentSection[0].classList.add('animate-out');
	}

	_onToggleClick(e) {
		const toggle = e.currentTarget;
		const sectionId = toggle.getAttribute('aria-controls');

		this.updateDetailSections(sectionId);
		this.updateToggles(toggle);
	}

	addEventListeners() {
		addListener(this.el.toggles, 'click', this.events._onToggleClick);
	}

	removeEventListeners() {
		removeListener(this.el.toggles, 'click', this.events._onToggleClick);
	}

	destory() {
		this.removeEventListeners();
	}

}
